/** Shared per-plan cap strings — English (structure pinned to fr). */
import type { PlanLimitKeys } from './fr';

const planLimitEn: PlanLimitKeys = {
  meterLabel: '{{used}} of {{limit}} used',
  meterUnlimited: '{{used}} used — unlimited on your plan',
  meterAria: 'Plan usage: {{used}} of {{limit}}',
  atLimit: 'Your plan limit is reached ({{limit}}).',
  upgradeHint: 'Upgrade to a higher plan to add more.',
  upgradeCta: 'See plans',
  limitReached: 'Plan limit reached: {{used}} of {{limit}}. Upgrade to a higher plan to create more.',
  overLimit: 'Over limit',
  overLimitHint:
    'Your current plan allows {{limit}} item(s). This one is kept read-only — nothing is deleted.',
  readOnly: 'Read only',
  adminUnlimited: '{{used}} used — Admin: all features (unlimited)',
};

export default planLimitEn;
